var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendrier(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26.995,
    viewBox: "0 0 27 26.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendrier",
    transform: "translate(-0.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M8.527,0a1.842,1.842,0,0,0-.758.163A1.811,1.811,0,0,0,6.746,1.481a4.621,4.621,0,0,0-.035.9c0,.068,0,.138,0,.206V2.7l-2.627.026a3.142,3.142,0,0,0-1.114.259A4.1,4.1,0,0,0,.762,5.089,4.3,4.3,0,0,0,.4,6.86V22.825a4.318,4.318,0,0,0,.327,1.7,4.1,4.1,0,0,0,2.139,2.14A4.289,4.289,0,0,0,4.562,27H23.335A4.115,4.115,0,0,0,25.9,26.08a4.005,4.005,0,0,0,.992-1.193,4.077,4.077,0,0,0,.477-1.477,6.1,6.1,0,0,0,.029-.736V6.759a4.1,4.1,0,0,0-.97-2.635,3.988,3.988,0,0,0-1.179-.945,4.16,4.16,0,0,0-1.441-.454h-.045L21.126,2.7V2.586q0-.1,0-.194c0-.223.006-.452-.005-.676A1.83,1.83,0,0,0,20.262.264,1.8,1.8,0,0,0,19.424,0a1.843,1.843,0,0,0-.864.159A1.811,1.811,0,0,0,17.536,1.48a4.617,4.617,0,0,0-.035.9c0,.067,0,.137,0,.206v.111H10.334v-.11c0-.062,0-.124,0-.187V2.392c0-.222.006-.451-.005-.674A1.829,1.829,0,0,0,9.472.264,1.8,1.8,0,0,0,8.633,0ZM23.051,26.074H4.517A3.277,3.277,0,0,1,3.2,25.805a3.1,3.1,0,0,1-1.087-.787,3.244,3.244,0,0,1-.791-2.2V8.112H25.47c.109,0,.22,0,.327.005.189,0,.383.009.57,0l.115-.006v13c0,.2,0,.4,0,.6,0,.394-.009.8,0,1.2v.029a3.162,3.162,0,0,1-.591,1.818,3.092,3.092,0,0,1-1.53,1.148,3.927,3.927,0,0,1-1.309.169M1.325,7.192V7.039c0-.142,0-.288,0-.434A3.108,3.108,0,0,1,1.571,5.54,3.158,3.158,0,0,1,2.985,3.989,2.8,2.8,0,0,1,4,3.652a1.918,1.918,0,0,1,.194,0h.089l2.429-.032v.3c0,.216,0,.438,0,.655a1.83,1.83,0,0,0,.855,1.472,1.8,1.8,0,0,0,.955.268,1.839,1.839,0,0,0,.761-.165,1.81,1.81,0,0,0,1.017-1.332,4.793,4.793,0,0,0,.032-.882c0-.063,0-.135,0-.2V3.616h7.171v.3c0,.216,0,.438,0,.655a1.83,1.83,0,0,0,.855,1.472,1.8,1.8,0,0,0,.953.268,1.84,1.84,0,0,0,.761-.165A1.81,1.81,0,0,0,21.1,4.813a4.793,4.793,0,0,0,.032-.882v0c0-.065,0-.133,0-.2V3.617l2.289.031h.119c.082,0,.165,0,.249,0a2.466,2.466,0,0,1,.818.229,3.172,3.172,0,0,1,1.531,1.435,3.119,3.119,0,0,1,.338,1.161c.016.187.015.377.013.56v.152H2.336c-.108,0-.219,0-.326-.005s-.217-.005-.326-.005c-.091,0-.171,0-.244.006Zm17.984-1.8-.062,0a.891.891,0,0,1-.681-.408.915.915,0,0,1-.139-.5V1.806a.889.889,0,0,1,1.723-.3,1.077,1.077,0,0,1,.053.37V4.495a.9.9,0,0,1-.895.9Zm-10.791,0-.061,0a.891.891,0,0,1-.681-.408.915.915,0,0,1-.139-.5V1.806A.889.889,0,0,1,9.36,1.5a1.077,1.077,0,0,1,.053.37V4.495a.9.9,0,0,1-.895.9Z",
    transform: "translate(0 0)",
    fill: "#9f8e74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M13.34,25.917H11.5v1.845H13.34Z",
    transform: "translate(-6.1 -14.255)",
    fill: "#9f8e74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M24.24,25.917H22.4v1.845H24.24Z",
    transform: "translate(-12.095 -14.255)",
    fill: "#9f8e74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M35.913,25.917H34.069v1.845h1.845Z",
    transform: "translate(-18.516 -14.255)",
    fill: "#9f8e74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M47.056,25.917H45.211v1.845h1.845Z",
    transform: "translate(-24.644 -14.255)",
    fill: "#9f8e74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M13.34,36.02H11.5v1.845H13.34Z",
    transform: "translate(-6.1 -19.811)",
    fill: "#9f8e74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M24.24,36.02H22.4v1.845H24.24Z",
    transform: "translate(-12.095 -19.811)",
    fill: "#9f8e74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M35.913,36.02H34.069v1.845h1.845Z",
    transform: "translate(-18.516 -19.811)",
    fill: "#9f8e74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M47.056,36.02H45.211v1.845h1.845Z",
    transform: "translate(-24.644 -19.811)",
    fill: "#9f8e74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M13.34,45.623H11.5v1.845H13.34Z",
    transform: "translate(-6.1 -25.093)",
    fill: "#9f8e74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M24.24,45.623H22.4v1.845H24.24Z",
    transform: "translate(-12.095 -25.093)",
    fill: "#9f8e74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M35.913,45.623H34.069v1.845h1.845Z",
    transform: "translate(-18.516 -25.093)",
    fill: "#9f8e74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M47.056,45.623H45.211v1.845h1.845Z",
    transform: "translate(-24.644 -25.093)",
    fill: "#9f8e74"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendrier);
export default __webpack_public_path__ + "static/media/calendrier.79da73106f2c0c93d14c537f49fd549b.svg";
export { ForwardRef as ReactComponent };